import { render, staticRenderFns } from "./WelcomeOption.vue?vue&type=template&id=79bc5fb0&"
import script from "./WelcomeOption.vue?vue&type=script&lang=js&"
export * from "./WelcomeOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports